var _g, _g2, _g3, _g4, _g5, _g6, _g7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCabrio = function SvgCabrio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_805",
    "data-name": "Group 805",
    width: 82.391,
    height: 27.86,
    viewBox: "0 0 82.391 27.86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M797.1,221.914a.465.465,0,0,1,0-.93h4.609a6.389,6.389,0,0,0-4.934-2.283l-17.753-1.738a8.279,8.279,0,0,1-4.8-1.652l-6.145-4.133c-.209-.14-.5-.341-.824-.571a31.233,31.233,0,0,0-3.053-1.979l-.105.23-.133.272a.372.372,0,0,0,.051.446l6.1,4.98a1.142,1.142,0,0,1-.765,2.023l-40.6-1.536c-.737-.027-1.481-.033-2.222-.019l-2.1.041-.136,0a3.995,3.995,0,0,0-4.016,3.763h2.339a.465.465,0,0,1,0,.93h-2.366v3.057h2.366a.465.465,0,0,1,0,.93h-2.35a8.235,8.235,0,0,0,.406,2.282h8.871a8.063,8.063,0,0,1,14.712,0h35.163a8.064,8.064,0,0,1,14.714,0h7.991a5.03,5.03,0,0,0,.145-4.109Zm-44.651-2.408h-2.408a.465.465,0,0,1,0-.93h2.408a.465.465,0,0,1,0,.93Z",
    transform: "translate(-720.244 -208.627)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(74.242 18.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M782.575,223.232a9.759,9.759,0,0,0,.563-.847H775.98a8.017,8.017,0,0,1,.039,4.621A9.867,9.867,0,0,0,782.575,223.232Z",
    transform: "translate(-775.98 -222.385)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    transform: "translate(59.378 13.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M771.967,233.105a7.129,7.129,0,0,0,6.313-3.864,6.97,6.97,0,0,0,.413-.954,6.646,6.646,0,0,0-.017-4.715,6.773,6.773,0,0,0-.414-.93,7.15,7.15,0,0,0-13.44,3.315,7.043,7.043,0,0,0,.432,2.359,6.967,6.967,0,0,0,.408.93A7.126,7.126,0,0,0,771.967,233.105Zm-3.959-9.533a4.52,4.52,0,1,1-.681,2.386A4.632,4.632,0,0,1,768.009,223.572Z",
    transform: "translate(-764.821 -218.811)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    transform: "translate(25.711 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M739.679,210.649a.625.625,0,0,0-.116.534l.721,3.01,1.95.073-1.485-3.475A.65.65,0,0,0,739.679,210.649Z",
    transform: "translate(-739.546 -210.429)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(0.799 18.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M720.844,222.385a8.27,8.27,0,0,0,7.467,4.745h.661a8.047,8.047,0,0,1,.007-4.745Z",
    transform: "translate(-720.844 -222.385)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(24.366 18.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M738.536,222.385a8.063,8.063,0,0,1,.008,4.745h34.428a8.063,8.063,0,0,1,.008-4.745Z",
    transform: "translate(-738.536 -222.385)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804",
    transform: "translate(9.503 13.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M734.524,233.105a7.127,7.127,0,0,0,6.309-3.859,7.376,7.376,0,0,0,.839-3.289,7.148,7.148,0,1,0-13.862,2.359,6.967,6.967,0,0,0,.408.93A7.126,7.126,0,0,0,734.524,233.105Zm-3.959-9.533a4.622,4.622,0,1,1,7.934,4.745,4.622,4.622,0,1,1-7.934-4.745Z",
    transform: "translate(-727.378 -218.811)",
    fill: "rgba(6,1,108,0.25)"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCabrio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cabrio.5f9c9917.svg";
export { ForwardRef as ReactComponent };